<div *ngIf="isVisible" class="snackbar-container align-items-center">

    <div class="text align-items-center">
        New updates are available , to load new version refresh the browser tab or press the 'Reload' button
    </div>
    
    <button (click)="reload()" class="btn">Reload</button>

</div>